import loadingIcon from "../../Images/Loading_icon.gif"

export const LoadingIcon = function () {
    return(
        <div style={{textAlign: "center"}}>
            <img src={loadingIcon} />
        </div>
    )
}